import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {Layout, Select, Input} from "antd";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/Common/PluginAddDeleteList2";
import {PostToPbx} from "../../../../api/http-post";
import {fetchDataEntity} from "../../../../api/entity-data";

class InvoiceSetupHeaderPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Clients: [],
            Items:[],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("modules", "Modules");
        await this.loadData("SettingInvoiceServiceDebtors", "Clients");
        await this.loadData("SettingInvoiceServiceItem", "Items");
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    getModuleList = () => {
        let ls = [];
        for (let i in this.state.Modules) {
            let row = this.state.Modules[i];
            if (row.org === this.state.newEntry.org) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getCompanyList = () => {
        let ls = [];
        for (let i in this.state.Companies) {
            let row = this.state.Companies[i];
            ls.push({
                key: row.CustomerNumber,
                val: row.Name,
            });
        }
        return ls;
    }

    getClientOption=()=>{
        let ls = [];
        for (let i in this.state.Clients) {
            let row = this.state.Clients[i];
            if (row.org === this.state.newEntry.selectedCompany) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getItemOption=()=>{
        let ls = [];
        for (let i in this.state.Items) {
            let row = this.state.Items[i];
            if (row.org === this.state.newEntry.selectedCompany && row.client===this.state.newEntry.selectedClient) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }

    render() {

        const companyOptions = this.getCompanyList();
        const clientOptions = this.getClientOption();
        const itemOptions = this.getItemOption();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup invoice header</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"SettingInvoiceServiceAddonHeader"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                }
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Company",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "client",
                                    dataType: "option",
                                    required: true,
                                    label: "Debtor",
                                    options: clientOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "item",
                                    dataType: "option",
                                    required: true,
                                    label: "Item | Job description",
                                    options: itemOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },

                                {
                                    name: "contractnumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Contract Number",
                                    options: []
                                },
                                {
                                    name: "contractdescription",
                                    dataType: "text",
                                    required: true,
                                    label: "Contract Desc",
                                    options: []
                                },
                                {
                                    name: "contractarea",
                                    dataType: "text",
                                    required: true,
                                    label: "Contract Area",
                                    options: []
                                },


                                {
                                    name: "fromcompanyname",
                                    dataType: "text",
                                    required: true,
                                    label: "Company Name",
                                    options: []
                                },
                                {
                                    name: "fromcompanydesc",
                                    dataType: "text",
                                    required: true,
                                    label: "Company Desc",
                                    options: []
                                },
                                {
                                    name: "fromcompanypobox",
                                    dataType: "text",
                                    required: true,
                                    label: "Company PoBox",
                                    options: []
                                },
                                {
                                    name: "fromcompanyaddressline1",
                                    dataType: "text",
                                    required: true,
                                    label: "Company Address Line1",
                                    options: []
                                },
                                {
                                    name: "fromcompanyaddressline2",
                                    dataType: "text",
                                    required: true,
                                    label: "Company Address Line2",
                                    options: []
                                },
                                {
                                    name: "fromcompanyregnumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Company RegNumber",
                                    options: []
                                },
                                {
                                    name: "fromcompanyvatnumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Company vatNumber",
                                    options: []
                                },
                                {
                                    name: "fromcompanysupplynumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Company SupplyNumber",
                                    options: []
                                },
                                {
                                    name: "fromcompanyvendornumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Company VendorNumber ",
                                    options: []
                                },



                                {
                                    name: "tocompanyname",
                                    dataType: "text",
                                    required: true,
                                    label: "Client Name",
                                    options: []
                                },
                                {
                                    name: "tocompanydesc",
                                    dataType: "text",
                                    required: true,
                                    label: "Client Desc",
                                    options: []
                                },
                                {
                                    name: "tocompanypobox",
                                    dataType: "text",
                                    required: true,
                                    label: "Client PoBox",
                                    options: []
                                },
                                {
                                    name: "tocompanyaddressline1",
                                    dataType: "text",
                                    required: true,
                                    label: "Client Address Line1",
                                    options: []
                                },
                                {
                                    name: "tocompanyaddressline2",
                                    dataType: "text",
                                    required: true,
                                    label: "Client Address Line2",
                                    options: []
                                },
                                {
                                    name: "tocompanyregnumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Client RegNumber",
                                    options: []
                                },
                                {
                                    name: "tocompanyvatnumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Client vatNumber",
                                    options: []
                                },
                                {
                                    name: "tocompanysupplynumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Client SupplyNumber",
                                    options: []
                                },
                                {
                                    name: "tocompanyvendornumber",
                                    dataType: "text",
                                    required: true,
                                    label: "Client VendorNumber ",
                                    options: []
                                },



                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "client", type: "string"},
                                {key: "item", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"SettingInvoiceServiceAddonHeader"}
                            addFormText={"Heading"}
                            stepTitle={"Set Up new header"}

                            filterByCompany={true}
                            displayRules={[
                                {rowKey:"org",stateKey:"selectedCompany"},
                                {rowKey:"client",stateKey:"selectedClient"},
                                {rowKey:"item",stateKey:"selectedItem"}
                            ]}
                            extraFilters={[
                                {
                                    recordKey:"key",
                                    recordValue:"val",
                                    stateKey:"client",
                                    filterRecordKey:"client",
                                    filterStateKey:"selectedClient",
                                    allowBlank:true,
                                    name:"selectedClient",
                                    label:"Debtor",
                                    options: clientOptions,
                                    errorMsg: "Sorry you can't save, Please select your client!"
                                },
                                {
                                    recordKey:"key",
                                    recordValue:"val",
                                    stateKey:"item",
                                    filterRecordKey:"item",
                                    filterStateKey:"selectedItem",
                                    allowBlank:true,
                                    name:"selectedItem",
                                    label:"Item | Job description",
                                    options: itemOptions,
                                    errorMsg: "Sorry you can't save, Please select your client!"
                                },
                            ]}


                        />

                    </div>
                </div>
            </Page>
        )
    }

}

export default Connector(InvoiceSetupHeaderPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

